import * as React from 'react';
import DateRange from 'src/components/common/DateRange';
import DateRangeModel from 'src/model/dateRange.model';
import * as moment from 'moment';
import {
  statusType,
  sortType,
  orderType,
  invoiceType,
  nardType,
  ordernumberType,
  poType
} from 'src/model/modules/invoices.model';

import SearchIcon from 'src/assets/searchIcon';
import CloseIcon from 'src/assets/close';
import DateRangeSelector from 'src/components/Invoices/components/DatePicker/index';

import './CSFilters.scss';

import { SET_INVOICES_DATA } from 'src/store/modules/invoices/types';
import ItemLoader from 'src/components/Lists/components/ItemLoader';
import { getInvoicesIsPendingSel } from 'src/store/modules/invoices';
import SearchFilter from 'src/components/ClaimStatus/components/CSSearchFilter';
import AllStatus from 'src/components/Invoices/components/Filter/AllStatus';

import MultipleSelectStatus from 'src/components/ClaimStatus/components/CSAllStatus';
import MultipleSelect from 'src/components/ClaimStatus/components/CSAllClaims';

import InvoiceService from 'src/services/invoice';
import Button from 'src/components/common/Button';
import i18n from 'src/translation/i18n';
import {
  ICSSvcFilters,
  ICSSvcPagination
} from 'src/services/claimStatus/claimStatusService';

interface ICSFiltersProps {
  t: any;
  datesFilter: DateRangeModel;
  statusFilter: statusType;
  disableSearch: boolean;
  csSearchKey: string;
  csSearchVal: string;
  sortFilter: { type: sortType; order: 'asc' | 'desc' };
  getCSHistory(filters: ICSSvcFilters, pagination: ICSSvcPagination): void;
  clearAlert: () => void;
  setfiltervalues: any;
}
interface ICSFiltersState {
  calendarIsOpen: boolean;
  searchValue: any;
  searchKeyVal: any;
  dateRange: object;
  open: boolean;
  isReset: boolean;
  cStatusSearch: any;
  date: any;
  status: any;
  disableSearch: boolean;
  displayDatePicker: boolean;
  isResetSearch: boolean;
}

export const SEARCH_FILTER_MAPPING = {
  'Claim Number': `${i18n.t('CSFilters.ClaimNumber')}`,
  'Original Invoice Number': `${i18n.t('CSFilters.OriInvNumber')}`,
  'Credit Invoice Number': `${i18n.t('CSFilters.CrInvNumber')}`,
  'Part Number': `${i18n.t('CSFilters.CSPartNumber')}`,
  'Your Reference Number': `${i18n.t('CSFilters.UrRefNumber')}`,
  'Original PO Number': `${i18n.t('CSFilters.OriPONumber')}`
};
class CSFilters extends React.Component<any, ICSFiltersState> {
  constructor(props: ICSFiltersProps) {
    super(props);

    this.state = {
      calendarIsOpen: false,
      searchValue: '',
      isReset: false,
      cStatusSearch: null,
      date: null,
      status: null,
      searchKeyVal: 'Claim Number',
      open: false,
      dateRange: {},
      disableSearch: true,
      displayDatePicker: true,
      isResetSearch: false
    };
    this.getFilteredClaims();
    // console.log("CSFilters - Const", props);
  }

  private clearFilterState = (
    dates: DateRangeModel | null = this.props.datesFilter,
    status: statusType = this.props.statusFilter,
    orderStatus: orderType = this.props.orderFilter,
    csSearchKey: string = this.props.csSearchKey,
    csSearchVal: string = this.props.csSearchVal
  ) => {
    const filters: ICSSvcFilters = {
      dateRange: dates,
      status,
      orderStatus,
      csSearchKey,
      csSearchVal,
      sort: { ...this.props.sortFilter }
    };
    this.props.setfiltervalues(filters);
  };

  private getFilteredClaims = (
    dates: DateRangeModel | null = this.props.datesFilter,
    status: statusType = this.props.statusFilter,
    orderStatus: orderType = this.props.orderFilter,
    csSearchVal: string = this.props.csSearchVal,
    csSearchKey: string = this.props.csSearchKey
  ) => {
    const filters: ICSSvcFilters = {
      dateRange: dates,
      status,
      orderStatus,
      csSearchVal,
      csSearchKey,
      sort: { ...this.props.sortFilter }
    };
    this.props.setfiltervalues(filters);
    const pagination: ICSSvcPagination = {
      page: 0
    };
    // console.log(filters, 'Filter Options');

    // this.props.getCSHistory(filters, pagination);
  };

  private setFilters = (searchKey: any, searchVal: any) => {
    const { checkReset } = this.props;
    this.setState({
      isReset: false,
      isResetSearch: false
    });
    if (searchKey) {
      this.setState({
        disableSearch: false,
        searchKeyVal: searchKey,
        searchValue: ''
      });
    } else {
      this.getFilteredClaims(
        this.state.date,
        this.state.status,
        this.state.cStatusSearch
      );
      this.setState({
        disableSearch: true,
        searchValue: '',
        searchKeyVal: 'Claim Number'
      });
    }
    checkReset(true);
  };

  private handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    // this.setFilters(this.state.searchKeyVal, event.currentTarget.value);
    this.setState({ searchValue: event.currentTarget.value.toUpperCase() });
    const { checkReset } = this.props;
    checkReset(true);
  };

  private handleClearSearch = () => {
    this.resetClaimStatusSearch();

    this.getFilteredClaims(
      this.state.date,
      this.state.status,
      this.state.cStatusSearch
    );
  };
  private handlesearch = () => {
    // let invoiceNumber = null;
    // let nardaNumber = null;
    // let orderNumber = null;
    // let orderReference = null;
    const searchKeyValue = this.state.searchKeyVal;
    const finalSearchValue = this.state.searchValue.trim();
    this.setState({ searchValue: finalSearchValue });
    // console.log(searchKeyValue);
    let csSearchKeyVal = null;
    let csSearchKey = null;
    csSearchKeyVal = finalSearchValue;
    csSearchKey = searchKeyValue;
    if (csSearchKey && csSearchKey === 'Claim Number') {
      this.getFilteredClaims(
        this.state.date,
        this.state.status,
        this.state.cStatusSearch,
        csSearchKey,
        csSearchKeyVal
      );
    } else if (csSearchKeyVal && searchKeyValue) {
      this.getFilteredClaims(
        this.state.date,
        this.state.status,
        this.state.cStatusSearch,
        csSearchKey,
        csSearchKeyVal
      );
    }
  };
  private handleSearchFOptions = (event: any) => {
    /* if (this.state.searchValue.toString().length >= 3) {
      this.handlesearch();
    }
    else */
    if (event.keyCode === 13) {
      if (
        this.state.searchKeyVal.trim() === 'Claim Number' &&
        this.state.searchValue.toString().length >= 3
      ) {
        const { checkReset } = this.props;
        checkReset(true);
        this.setState({
          isReset: true,
          disableSearch: true
        });
      }
      this.handlesearch();
    }
  };

  private handleSearchFOptions1 = (event: any) => {
    // console.log(this.state.searchValue.trim());
    // console.log(event.keyCode);
    /* if (event.keyCode === 13) {
      if (this.state.searchKeyVal.trim() === "Claim Number") {
        this.getFilteredClaims(null, null, null, this.state.searchKeyVal, this.state.searchValue);
      }
    }
    else */
    const { checkReset } = this.props;
    // debugger;
    checkReset(true);
    if (event.keyCode === 13 && this.state.searchValue.toString().length > 3) {
      this.handlesearch();
    } else {
      if (
        this.state.searchKeyVal.trim() === 'Claim Number' &&
        this.state.searchValue.toString().length >= 3
      ) {
        this.clearFilters(null, this.state.searchValue.toString());
      } else {
        this.setState({
          disableSearch: false
        });
      }
      if (this.state.searchValue.trim() > 3) {
        this.handlesearch();
      } else {
        console.log('Please enter minimum 3 characters to search');
      }
    }
  };

  private handleKeyPress = (event: any) => {
    if (event.keyCode === 13 && this.state.searchValue.toString().length > 3) {
      this.handlesearch();
    } else if (this.state.searchValue.toString().length > 3) {
      this.handlesearch();
    }
    /*  if (event.keyCode === 13) {
        if (this.state.searchKeyVal.trim() === "Claim Number" &&
          this.state.searchValue.toString().length > 3) {
          this.clearFilters(null);
        }
        this.handlesearch();
      } */
  };

  public clearFilters = (filters: null, sKey?: string) => {
    const { checkReset } = this.props;
    checkReset(true);
    this.getFilteredClaims(null, null, null);
    this.setState({
      isReset: true,
      searchValue: sKey === undefined ? '' : sKey,
      date: null,
      cStatusSearch: null,
      status: null,
      searchKeyVal: 'Claim Number',
      open: false,
      dateRange: {},
      disableSearch: true,
      displayDatePicker: false
    });
    setTimeout(() => {
      this.setState({ displayDatePicker: true });
    }, 50);
  };

  public resetClaimStatusSearch = () => {
    // console.log(this.state.searchKeyVal);
    this.setState({
      searchValue: '',
      searchKeyVal: this.state.searchKeyVal, // 'Claim Number',
      disableSearch: true,
      isResetSearch: false
    });
  };

  public filterByCSAllClaims = (invoice: any) => {
    this.setState({ cStatusSearch: invoice });
    this.getFilteredClaims(
      this.state.date,
      this.state.status,
      invoice,
      this.state.searchKeyVal,
      this.state.searchValue
    );
    this.setState({ isReset: false });
    // this.resetClaimStatusSearch();
    const { checkReset, setFirstActive } = this.props;
    checkReset(true);
  };
  public filterByStatus = (statusValue: any) => {
    this.setState({ status: statusValue });
    this.getFilteredClaims(
      this.state.date,
      statusValue,
      this.state.cStatusSearch,
      this.state.searchKeyVal,
      this.state.searchValue
    );
    this.setState({ isReset: false });
    // this.resetClaimStatusSearch();
    const { checkReset } = this.props;
    checkReset(true);
  };

  public filterByDate = (dateRange: any) => {
    this.setState({ date: dateRange });
    this.getFilteredClaims(
      dateRange,
      this.state.status,
      this.state.cStatusSearch,
      this.state.searchKeyVal,
      this.state.searchValue
    );
    this.setState({ isReset: false });
  };

  public toggle = () => this.setState({ open: !this.state.open });

  public setCurrentDateRange = (range: any) => {
    this.setState({ dateRange: range });
  };

  public handleDatePickerApply = (range: any) => {
    if (range['startDate'] && range['endDate']) {
      this.setState({ dateRange: range });
      const start = moment(range['startDate']);
      const end = moment(range['endDate']);
      this.filterByDate({ start, end });
      this.setState({ open: false });
      // this.resetClaimStatusSearch();
      const { checkReset } = this.props;
      checkReset(true);
    }
  };

  public componentDidUpdate = () => {
    const { cardActive, SetCardActiveStatus } = this.props;
    if (cardActive) {
      this.setState({
        isReset: true,
        searchValue: '',
        date: null,
        cStatusSearch: null,
        status: null,
        searchKeyVal: 'Claim Number',
        open: false,
        dateRange: {}
      });
      SetCardActiveStatus(false);
      this.clearFilterState(null, null, null);
    }
  };

  public getPlaceHolderText = () => {
    // console.log(this.state.searchKeyVal);
    return `${i18n.t('invoices.searchBy')}`;
    if (this.state.searchKeyVal) {
      const selected = SEARCH_FILTER_MAPPING[this.state.searchKeyVal]
        ? SEARCH_FILTER_MAPPING[this.state.searchKeyVal]
        : i18n.t('invoices.purchaseOrderNo').toString();
      const placeholder = `${i18n.t('invoices.searchBy')} ${selected}`;
      return placeholder;
    }
    if (window.innerWidth < 1024) {
      return null;
    }
    return `${i18n.t('CSFilters.ClaimNumber')}`;
  };

  public render() {
    const {
      searchKeyVal,
      open,
      isReset,
      dateRange,
      searchValue,
      isResetSearch
    } = this.state;
    return (
      <>
        <div className="searchClear-container col-md-12">
          <div
            className="filtersSection row row-col-1"
            style={{ float: 'left' }}
          >
            <MultipleSelect
              filter={this.filterByCSAllClaims}
              isReset={isReset}
              status={this.state.status}
              className={
                this.state.disableSearch
                  ? 'disable-search csFilter1'
                  : 'csFilter1'
              }
            />
            <MultipleSelectStatus
              filter={this.filterByStatus}
              isReset={isReset}
              cStatusSearch={this.state.cStatusSearch}
              className={
                this.state.disableSearch
                  ? 'disable-search csFilter2'
                  : 'csFilter2'
              }
            />
            {this.state.displayDatePicker && (
              <div className="rp-tracking-filterbar csFilter3 nopaddingl0 col-md-4 col-sm-12 col-lg-2 col-xs-12">
                <div className="rp-tracking-filterbar--filters">
                  <div className="filters-components">
                    <div className="date-range-container">
                      <DateRangeSelector
                        isReset={isReset}
                        open={open}
                        dateRange={dateRange}
                        toggle={this.toggle}
                        setCurrentDateRange={this.setCurrentDateRange}
                        handleDatePickerApply={this.handleDatePickerApply}
                        className={
                          this.state.disableSearch ? 'disable-search' : ''
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="wrapper csFilter4  col-md-8 col-sm-12 col-lg-4 col-xs-12">
              {/* <div className="wrapper-container"> */}
              <SearchFilter
                setFilters={this.setFilters}
                isReset={isReset}
                isResetSearch={isResetSearch}
              />
              <div className="search-container col-5 noplr0">
                <input
                  type="text"
                  placeholder={this.getPlaceHolderText()}
                  style={{
                    borderTopRightRadius: '5px',
                    borderBottomRightRadius: '5px',
                    paddingLeft: '10px',
                    fontSize: '0.9vw',
                    paddingRight: '50px'
                  }}
                  onChange={this.handleChange}
                  onKeyUpCapture={this.handleSearchFOptions}
                  // onKeyUp={this.handleSearchFOptions}
                  value={searchValue}
                  // className={this.state.disableSearch ? 'disable-search' : ''}
                />
                {searchValue && (
                  <img
                    className="close-icon"
                    alt="clear"
                    src={CloseIcon}
                    onClick={this.handleClearSearch}
                    style={{ top: '17px', right: '34px' }}
                  />
                )}
                <img
                  className="search-icon"
                  alt="search"
                  src={SearchIcon}
                  onClick={this.handlesearch}
                  style={{ top: '14px', width: '20px' }}
                />
              </div>
              {this.state.searchValue &&
                this.state.searchValue.length > 0 &&
                this.state.searchValue.length < 3 && (
                  <div
                    className="error-message-to-show SFCriteriaErrMsg"
                    style={{ zIndex: 9, left: '30px' }}
                  >
                    {i18n.t('claimStatus.csSearchValErrMsg1')}
                  </div>
                )}
            </div>
            <button
              className="clear-filters w-auto csFilter5"
              onClick={this.clearFilters}
            >
              {i18n.t('common.clearAllFiters')}
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default CSFilters;
